export enum PartSaveStatusType {
  Unknown = 'Unknown',
  Unchanged = 'Unchanged',
  Saved = 'Saved',
  Unsaved = 'Unsaved',
  Invalid = 'Invalid',
}
